import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainReality() {
  const pains = ['No tengo tiempo, mis hijos me consumen el día.', 'No soy experta en nada, ¿qué podría enseñar?', 'No sé usar programas de diseño complicados.', 'Me da pena vender o mostrar mi cara en redes.', 'Siento que ya hay mucha competencia.'];
  return <section className="bg-white py-16 md:py-24 px-4 border-t border-slate-100" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-162">
          <h2 className="text-3xl md:text-5xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-163">
            Si has pensado "yo no nací para vender"...{' '}
            <br className="hidden md:block" data-id="element-164" />
            <span className="text-primary" data-id="element-165">
              no es verdad. Solo te falta el mapa.
            </span>
          </h2>
        </motion.div>

        <div className="bg-slate-50 rounded-[32px] p-8 md:p-12 border border-slate-200 shadow-sm" data-id="element-166">
          <h3 className="text-xl md:text-2xl font-bold text-dark mb-8 text-center" data-id="element-167">
            ¿Te sientes atrapada entre alguna de estas frases?
          </h3>

          <div className="space-y-4 max-w-2xl mx-auto" data-id="element-168">
            {pains.map((pain, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-4 bg-white p-4 rounded-2xl border border-slate-100 shadow-sm" data-id="element-169">
                <XCircle className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-170" />
                <p className="text-lg text-slate-600 font-medium" data-id="element-171">{pain}</p>
              </motion.div>)}
          </div>

          <div className="mt-10 text-center" data-id="element-172">
            <p className="text-xl text-dark font-bold" data-id="element-173">
              La realidad: No necesitas más tiempo ni talento. <br data-id="element-174" />
              <span className="text-primary" data-id="element-175">
                Necesitas un sistema que haga el trabajo pesado por ti.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}